import { useState } from "react";

import { ManageSubscriptionDialog } from "features/subscriptions/components";

import RestrictedComponent from "common/components/RestrictedComponent";
import { Button } from "common/components/ui/Button";
import { getWhitelabelCustomization } from "common/helpers/utils";

export default function RentAccountsButton({ size }: { size: "sm" | "md" }) {
  const [isOpen, setIsOpen] = useState(false);

  if (!getWhitelabelCustomization()) {
    return (
      <RestrictedComponent visibleFor={["billing_full"]}>
        <Button
          size={size}
          onClick={() => setIsOpen(true)}
          variant="secondary-purple"
        >
          Rent avatars
        </Button>

        <ManageSubscriptionDialog
          initialState="rental"
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          mixpanelSource="upsell_seat"
        />
      </RestrictedComponent>
    );
  }
}
